import { api } from './client';
import type { IngredientLibraryItem } from '../types';

export function searchIngredients(
  q: string,
  limit = 10,
): Promise<{ items: IngredientLibraryItem[] }> {
  const params = new URLSearchParams();
  if (q) params.set('q', q);
  params.set('limit', String(limit));
  return api(`/api/ingredients?${params.toString()}`);
}

export function createIngredient(
  body: Partial<IngredientLibraryItem> & { name: string },
): Promise<{ id: string }> {
  return api('/api/ingredients', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function updateIngredient(
  id: string,
  body: Partial<IngredientLibraryItem>,
): Promise<{ ok: true }> {
  return api(`/api/ingredients/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function deleteIngredient(id: string): Promise<{ ok: true }> {
  return api(`/api/ingredients/${id}`, { method: 'DELETE' });
}
